import React, { useEffect, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { deriveUserId } from "../utils/CryptoHelpers";
import bs58 from 'bs58';
import { loadLocalKeys } from '../db/KeyStorageManager';
import { usePasswordAndUserId } from "../context/AuthContext";

export default function SettingsView({
  unlinkSecret,
  decryptSecret,
  onImportSecret,
  onRevealSecret,
  onLogout,
  onFundWallet,
  onSetWipePassword,
}) {
  const [showSecret, setShowSecret] = useState(false);
  const [secretValue, setSecretValue] = useState(null);
  const [viewPublicKey, setViewPublicKey] = useState(null);
  const {password, userId, salt} = usePasswordAndUserId();

  useEffect(() => {
    async function fetchKeys() {
      const keys = await loadLocalKeys({ userId, password, salt });
      setViewPublicKey(keys?.viewPublicKey || null);
    }

    fetchKeys();
  }, [userId, password, salt]);

  const handleRevealSecret = async () => {
    const input = prompt("Enter your password to reveal the Unlink secret:");
    if (!input) return;

    if (input === password) {
      const decrypted = await decryptSecret(unlinkSecret, input);
      setSecretValue(decrypted);
      setShowSecret(true);
    } else {
      alert("Incorrect password.");
    }
  };

  const menuItem = (label, onClick, danger = false) => (
    <div
      onClick={onClick}
      style={{
        padding: "1rem",
        borderBottom: "1px solid #333",
        color: danger ? "#f66" : "#fff",
        cursor: "pointer",
        backgroundColor: "#111",
      }}
    >
      {label}
    </div>
  );

  if (!viewPublicKey) return null;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        backgroundColor: "#000",
        color: "#fff",
      }}
    >
      {/* Header */}
      <div
        style={{
          position: "sticky",
          top: 0,
          zIndex: 10,
          backgroundColor: "#000",
          borderBottom: "1px solid #222",
          padding: "1rem",
        }}
      >
        <h2 style={{ margin: 0 }}>Settings</h2>
      </div>

      {/* Scrollable content */}
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          boxSizing: "border-box",
        }}
      >
        {/* View Key QR */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "1.5rem",
          }}
        >
          <QRCodeSVG value={bs58.encode(viewPublicKey)} size={128} bgColor="#000" fgColor="#fff" />
          <div
            style={{
              marginTop: "1rem",
              wordBreak: "break-all",
              textAlign: "center",
              fontSize: "0.9rem",
              color: "#ccc",
            }}
          >
            {bs58.encode(viewPublicKey)}
          </div>
          <div
            style={{
              marginTop: "0.5rem",
              fontSize: "0.75rem",
              color: "#888",
              textAlign: "center",
              maxWidth: "300px",
            }}
          >
            Your contact address. Scan or copy to start chats from other devices.
          </div>
        </div>

        {/* Menu Items */}
        <div style={{ marginTop: "1rem" }}>
          {menuItem("Show Unlink Secret", onRevealSecret)}
          {menuItem("Import Unlink Secret", onImportSecret)}
          {menuItem("Set Wipe Password", onSetWipePassword)}
          {menuItem("Fund Wallet", onFundWallet)}
          {menuItem("Log Out", onLogout, true)}
        </div>

        {/* Security warning */}
        <div
          style={{
            margin: "2rem 1rem 1rem",
            fontSize: "0.7rem",
            color: "#f66",
            textAlign: "center",
            lineHeight: "1.4",
          }}
        >
          Never share your Unlink secret. It can be used to read all messages sent to you. Store it offline or in a secure vault.
        </div>
      </div>
    </div>
  );
}